import { render, staticRenderFns } from "./FilterListComponent.vue?vue&type=template&id=472cafd0"
import script from "./FilterListComponent.vue?vue&type=script&lang=js"
export * from "./FilterListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports